export default {"src":"/_next/static/media/frc-colors.1bef9651.svg","height":1024,"width":1024,"blurWidth":0,"blurHeight":0};